export const ETL_LS = {
  DEFAULT_PORT: '4001',
};
